import { useEffect } from 'react';
import {
  NavLink,
} from 'react-router-dom';
import scrollTop from '../../function';

function Entrainement({ handler, setMenuVisibility }) {
  useEffect(() => {
    scrollTop();
    handler('entrainement');
    setMenuVisibility(false);
  }, []);
  return (
    <div className="container-content">
      <div className="container-width">
        <h2 className="title-content">Les entraînements</h2>
        <h3 className="title-category">Adultes</h3>
        <div className="p-i-flex">
          <div className="cart">
            <p>Tous les <span className="bold"> Mardis</span> de <span className="bold">20h30 à 22h30</span></p>
            <p>Centre sportif Solvay de La Hulpe</p>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2525.0284243061124!2d4.483566116035862!3d50.73796167951589!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c3d0c9e4eecc07%3A0xdaa7a74e1dfbf11e!2sRugby%20Club%20La%20Hulpe!5e0!3m2!1sfr!2sbe!4v1601550103676!5m2!1sfr!2sbe" width="100%" height="320" frameBorder="0" style={{ border: 0 }} allowFullScreen="" aria-hidden="false" tabIndex="0" />
          </div>
          <div className="cart">
            <p>Tous les <span className="bold"> jeudis</span> de <span className="bold">20h à 22h</span></p>
            <p>Complexe sportif de Limal</p>
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2527.042772953562!2d4.5833176999999985!3d50.70059079999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c3d7b7a2e09d59%3A0xc4635ae51b59d1b4!2sCentre%20sportif%20de%20Limal!5e0!3m2!1sfr!2sbe!4v1707763670996!5m2!1sfr!2sbe" width="100%" height="320" frameBorder="0" style={{ border: 0 }} allowFullScreen="" aria-hidden="false" tabIndex="0" />
          </div>
        </div>
        <h3 className="title-category">Junior</h3>
        <div className="cart">
          <p>Tous les <span className="bold"> dimanches</span> de <span className="bold">16h30 à 18h</span></p>
          <p>Complexe sportif de Limal</p>
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2527.042772953562!2d4.5833176999999985!3d50.70059079999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c3d7b7a2e09d59%3A0xc4635ae51b59d1b4!2sCentre%20sportif%20de%20Limal!5e0!3m2!1sfr!2sbe!4v1707763670996!5m2!1sfr!2sbe" width="100%" height="320" frameBorder="0" style={{ border: 0 }} allowFullScreen="" aria-hidden="false" tabIndex="0" />
        </div>
        <div className="btn-basis contact-training"><NavLink id="contact" to="/contact">Plus d&apos;infos? Contactez-nous<i className="fas fa-caret-right" /> </NavLink></div>
      </div>
    </div>
  );
}

export default Entrainement;
